import { Link, graphql } from 'gatsby'
import { MDBCard, MDBCardBody, MDBCol, MDBContainer, MDBRow } from 'mdbreact'

import Layout from '../components/layout'
import React from 'react'
import SEO from '../components/seo'
import SitemapMenu from '../components/menus/sitemapmenus'
import styled from 'styled-components'

let gmdv = require(`../ghc_config`)

const MDBCardCompMenu = styled(MDBCard)`
  width: 100%;
  margin: 0px;
  padding: 0px;
  position: relative;
  left: 50%;
  top: 14px !important;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  z-index: 1;
`

const MDBCardBodyComp = styled(MDBCardBody)`
  text-align: left;
  h5 {
    margin-bottom: 0rem;
  }
  ul {
    width: 100%;
    margin: 0px;
    padding: 0px;
    list-style-position: outside;
    list-style: none;
    li {
      width: 100%;
      background: none;
      #border-bottom: 1px #ccc solid;
      padding: 0em 0.1em;
      margin: 0 auto;
      display: inline-block;
      a {
        color: #575549;
        font-size: 0.8em;
      }
      li {
        padding: 0em 0.4em;
        border-bottom: none;
      }
    }
  }
`

const TroyHills = ({ data }) => {
  let MainMenu = data.allMenuLinkContentMenuLinkContent.edges

  return (
    <Layout>
      <SEO title={`Genesis HealthCare > Troy Hills Financial Disclorsure`} />
      <main>
        <MDBContainer tag="section" id="maincontent">
          <MDBCardCompMenu>
            <MDBCardBodyComp className="d-md-inline">
              <h3 className="pagetitle">
                Genesis Healthcare New Jersey Financial Transparency Statement
              </h3>
              <div>
                The current website of Troy Hills can be found at{' '}
                <a href="https://excelcaretroyhills.com/" target="_blank">
                  https://excelcaretroyhills.com/
                </a>
              </div>
              <div>
                <a
                  href="../CenterFinancialStatement/Troy_Hills_Financial_Stmts_2025-12-31.pdf"
                  target="_blank"
                >
                  Troy Hills Financial Stmts 2025-12-31
                </a>
              </div>
              <div>
                <a
                  href="../CenterFinancialStatement/Troy_Hills_Medicare_cost_report_2025-12-31.pdf"
                  target="_blank"
                >
                  Troy Hills Medicare cost report 2025-12-31
                </a>
              </div>{' '}
              <div>
                <a
                  href="../CenterFinancialStatement/Genesis_Financial_Reporting_Final_Issued_FY25_w_Audit_Opinion.pdf"
                  target="_blank"
                >
                  Genesis Financial Reporting Final Issued FY25 with Audit
                  Opinion
                </a>
              </div>
            </MDBCardBodyComp>
          </MDBCardCompMenu>
        </MDBContainer>
      </main>
    </Layout>
  )
}

export default TroyHills

export const query = graphql`
  query troyhills {
    #Mainmenu
    allMenuLinkContentMenuLinkContent(
      sort: { fields: [weight], order: ASC }
      filter: { menu_name: { eq: "main" } }
    ) {
      edges {
        node {
          drupal_id
          title
          link {
            uri
            title
          }
          drupal_parent_menu_item
          menu_name
        }
      }
      totalCount
    }
  }
`
